import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Breadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import "./permissions-terms-privacy.css";
import { useLanguage } from "../../i18n/LanguageContext";

const PermissionsTermsPrivacy = () => {
  const { tr } = useLanguage();
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== "undefined") return window.innerWidth <= 768;
    return false;
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div className="permissions-terms-page">
      <section className="permissions-terms-section">
        <Breadcrumbs />
        <motion.h1
          className="permissions-terms-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: isMobile ? 0.3 : 0.5 }}
        >
          {tr("Permissions & Terms Privacy", "Izin & Ketentuan Privasi")}
        </motion.h1>
        <p className="permissions-terms-intro">
          {tr(
            "By using our website and services, you agree to the following terms and permissions. Please read them carefully.",
            "Dengan menggunakan situs dan layanan kami, Anda setuju dengan ketentuan dan izin berikut. Harap baca dengan saksama."
          )}
        </p>

        <div className="permissions-terms-content">
          <motion.div
            className="permissions-terms-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.4 }}
          >
            <h2 className="permissions-terms-heading">
              {tr("Acceptance of Terms", "Penerimaan Ketentuan")}
            </h2>
            <p>
              {tr(
                "Accessing or using the Metagent website and any related services constitutes your acceptance of these terms. If you do not agree, please do not use our site or provide your personal information.",
                "Mengakses atau menggunakan situs Metagent dan layanan terkait berarti Anda menerima ketentuan ini. Jika tidak setuju, harap jangan gunakan situs kami atau berikan data pribadi Anda."
              )}
            </p>
          </motion.div>

          <motion.div
            className="permissions-terms-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.4 }}
          >
            <h2 className="permissions-terms-heading">
              {tr("Permissions We Use", "Izin yang Kami Gunakan")}
            </h2>
            <p>
              {tr(
                "We may collect and use the following with your consent:",
                "Kami dapat mengumpulkan dan menggunakan hal berikut dengan persetujuan Anda:"
              )}
            </p>
            <ul>
              <li>
                {tr(
                  "Email address — for newsletter updates, product news, and replying to your inquiries.",
                  "Alamat email — untuk update newsletter, berita produk, dan menjawab pertanyaan Anda."
                )}
              </li>
              <li>
                {tr(
                  "Information you submit via contact or inquiry forms — to respond and deliver our services.",
                  "Informasi yang Anda kirim melalui form kontak atau pertanyaan — untuk merespons dan menyediakan layanan kami."
                )}
              </li>
              <li>
                {tr(
                  "Basic usage data (e.g. pages visited) — to improve our website and user experience.",
                  "Data penggunaan dasar (mis. halaman yang dikunjungi) — untuk meningkatkan situs dan pengalaman pengguna."
                )}
              </li>
            </ul>
          </motion.div>

          <motion.div
            className="permissions-terms-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            <h2 className="permissions-terms-heading">
              {tr("Your Responsibilities", "Tanggung Jawab Anda")}
            </h2>
            <p>
              {tr(
                "You agree to use our services only for lawful purposes and in a way that does not harm others or our systems. You must not attempt to gain unauthorized access, distribute malware, or misuse any data or tools we provide.",
                "Anda setuju untuk menggunakan layanan kami hanya untuk tujuan yang sah dan dengan cara yang tidak merugikan pihak lain atau sistem kami. Anda tidak boleh mencoba akses tanpa izin, menyebarkan malware, atau menyalahgunakan data atau alat yang kami sediakan."
              )}
            </p>
          </motion.div>

          <motion.div
            className="permissions-terms-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.4 }}
          >
            <h2 className="permissions-terms-heading">
              {tr("Changes to These Terms", "Perubahan atas Ketentuan Ini")}
            </h2>
            <p>
              {tr(
                "We may update these terms from time to time. The current version will always be available on this page. Continued use of our site after changes constitutes acceptance of the updated terms. We encourage you to check this page periodically.",
                "Kami dapat memperbarui ketentuan ini dari waktu ke waktu. Versi terbaru selalu tersedia di halaman ini. Penggunaan situs kami yang berlanjut setelah perubahan berarti penerimaan ketentuan yang diperbarui. Kami menyarankan Anda memeriksa halaman ini secara berkala."
              )}
            </p>
          </motion.div>

          <motion.div
            className="permissions-terms-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.4 }}
          >
            <h2 className="permissions-terms-heading">
              {tr("Contact", "Kontak")}
            </h2>
            <p>
              {tr(
                "For questions about these permissions and terms, please contact us via the contact form on our website or at the email address provided in the footer.",
                "Untuk pertanyaan tentang izin dan ketentuan ini, silakan hubungi kami melalui form kontak di situs kami atau ke alamat email yang tercantum di footer."
              )}
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PermissionsTermsPrivacy;
